<div class="enroll-card enroll-card--boxed">
    <div class="enroll-page-header text-center">
        <mat-icon class="enroll-hero-icon">mark_email_read</mat-icon>
        <h1>Email Verification</h1>
        <p class="page-description">Confirm the code we sent to your inbox</p>
    </div>

    <div *ngIf="step === 'loading'" class="flex justify-center items-center p-12">
        <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="step === 'verify'" class="enroll-section-body">
        <div *ngIf="infoMessage" class="mb-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
            <p class="text-blue-700 text-sm flex items-center">
                <mat-icon inline class="text-base mr-2">info</mat-icon>
                {{ infoMessage }}
            </p>
        </div>

        <p class="text-gray-600 text-center mb-6 text-sm">
            We've sent a verification code to <strong class="text-gray-800">{{ maskedEmail }}</strong><br>
            <span class="text-sm text-gray-500">Please check your inbox (it might be in your spam folder)</span>
        </p>

        <div class="max-w-md mx-auto mb-6" *ngIf="!isTimerExpired && otpExpiresAt">
            <label class="block text-sm font-medium text-gray-700 mb-2 text-center">Verification Code</label>
            <input
                [(ngModel)]="code"
                type="text"
                placeholder="Enter code"
                class="w-full p-2.5 border border-gray-300 rounded-lg text-center text-base tracking-widest uppercase focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent"
                maxlength="6"
            />
        </div>

        <div class="mb-6">
            <div *ngIf="errorMessage && !isTimerExpired" class="bg-red-50 border-l-4 border-red-500 p-4 rounded mb-3">
                <p class="text-red-700 text-sm text-center flex items-center justify-center">
                    <mat-icon inline class="text-base mr-2">error</mat-icon>
                    {{ errorMessage }}
                </p>
            </div>

            <div *ngIf="timeLeft > 0 && !isTimerExpired" class="bg-gray-50 border border-gray-200 p-3 rounded">
                <p class="text-gray-700 text-sm text-center">
                    Code expires in: <strong>{{ formatTime() }}</strong>
                </p>
            </div>

            <div *ngIf="isTimerExpired || (!otpExpiresAt && !isEmailVerified)" class="bg-orange-50 border-l-4 border-orange-500 p-4 rounded">
                <p class="text-orange-700 text-sm text-center mb-3">
                    Your verification code has expired.
                </p>
                <p class="text-center text-sm text-gray-600">
                    <span *ngIf="!isResending">
                        Would you like us to send a new one?
                        <button
                            (click)="requestNewCode()"
                            class="text-[#1e3a5f] hover:underline font-medium">
                            Send a new code
                        </button>
                    </span>
                    <span *ngIf="isResending" class="text-[#1e3a5f] font-medium">
                        Sending new code...
                    </span>
                </p>
            </div>
        </div>

        <div class="max-w-md mx-auto mb-6" *ngIf="!isTimerExpired && otpExpiresAt">
            <button
                (click)="verifyCode()"
                [disabled]="!code || code.length < 6"
                class="enroll-btn enroll-btn--primary w-full disabled:opacity-50">
                Verify Code
            </button>
        </div>

        <div class="border-t border-gray-200 pt-4 text-center">
            <p class="text-sm text-gray-500">
                Wrong email address?
                <button
                    (click)="changeEmail()"
                    class="text-[#1e3a5f] hover:underline font-medium">
                    Change Email
                </button>
            </p>
        </div>
    </div>
</div>
